import { Property } from '@model';
import { useWishlist } from '@providers';
import { useTranslation } from 'react-i18next';

type WishlistWidgetProps = {
  property: Property;
};

export const WishlistWidget = ({ property }: WishlistWidgetProps) => {
  const { t } = useTranslation();

  const { addToWishlist, isInWishlist, removeFromWishlist } = useWishlist();
  const inWishlist = isInWishlist(property.id);

  const handleClick = () => {
    if (isInWishlist(property.id)) {
      removeFromWishlist(property.id);
    } else {
      addToWishlist(property);
    }
  };

  return (
    <div className='ltn__product-details-menu-3'>
      <ul>
        <li className={inWishlist ? 'active' : ''}>
          <a title='Wishlist' onClick={handleClick}>
            <i className='fas fa-heart'></i>
            <span>
              {inWishlist
                ? t('wishlistWidget.inWishlist')
                : t('wishlistWidget.addToWishlist')}
            </span>
          </a>
        </li>
      </ul>
    </div>
  );
};
